<template>
  <mj-nothing-found v-if="isDirty" />
  <mj-ready-for-search v-else />
</template>

<script>
import ReadyForSearch from '@/components/ui/content-placeholder/ReadyForSearch.vue';
import NothingFound from '@/components/ui/content-placeholder/NothingFound.vue';

export default {
  name: 'TracksTableContentPlaceholder',

  components: {
    'mj-ready-for-search': ReadyForSearch,
    'mj-nothing-found': NothingFound,
  },

  props: {
    isDirty: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
};

</script>
